import 'researcher/digital-orders/styles/digital-purchase-features.scss';
import React from 'react';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
var AvailableDigitalTranslationPurchasesFeatures = function AvailableDigitalTranslationPurchasesFeatures(_ref) {
  var hasAvailableDigitalTranslationPurchases = _ref.hasAvailableDigitalTranslationPurchases;
  return /*#__PURE__*/React.createElement("div", {
    className: "card digital-translations-package-features bg-white mt-4 mt-md-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "pb-1 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "digital-translation-packages"
  })), /*#__PURE__*/React.createElement("h4", {
    className: "pb-1 text-center"
  }, /*#__PURE__*/React.createElement(T, {
    source: "digital-translation-lowest-package-price"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "digital-translations-feature-list"
  }), hasAvailableDigitalTranslationPurchases ? /*#__PURE__*/React.createElement("div", {
    className: "text-center mb-2 pt-1"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "btn btn-success",
    to: "/researcher/digital-translations/purchase"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Subscribe"
  }))) : null));
};
export default AvailableDigitalTranslationPurchasesFeatures;